import React, { useMemo } from "react";
import PropTypes from "prop-types";
import Error from "./Error";
import Footer from "./Footer";
import PinnedElement from "venuescanner-js/react/components/PinnedElement";
import { RefShape } from "venuescanner-js/react/shapes";
import isDesktop from "../../../helpers/isDesktop";
import FilterPopup from "venuescanner-js/react/components/FilterPopup";

const Content = ({
  isActive,
  close,
  buttonRef,
  zIndex,
  title,
  children,
  error,
  apply,
  reset,
  hideClearFiltersCta,
}) => {
  const isWideEnough = useMemo(() => isDesktop(), []);
  const content = (
    <FilterPopup isActive={isActive} onClose={close} title={title} style={{}}>
      <main>{children}</main>
      {error && <Error text={error.message || error} />}
      <Footer
        apply={apply}
        reset={reset}
        close={close}
        hideClearFiltersCta={hideClearFiltersCta}
      />
    </FilterPopup>
  );

  if (!isWideEnough) return content;

  return (
    <PinnedElement
      pinTo={buttonRef}
      style={{ right: "1rem" }}
      inheritWidth={false}
    >
      {content}
    </PinnedElement>
  );
};

Content.propTypes = {
  isActive: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  buttonRef: RefShape.isRequired,
  zIndex: PropTypes.number,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,

  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object,
  ]),
  apply: PropTypes.func,
  reset: PropTypes.func,
};

export default Content;
